<template class="employeeList">
  <div style="display: flex;flex-direction: row">
    <div class="custom-tree-container" style="width: 20%;overflow-x:scroll;white-space: nowrap; height: 85vh;">
      <el-input
          v-model="filterText"
          style="width: 200px; line-height: 50px; margin-bottom: 10px;"
          placeholder="输入关键字进行过滤"/>
      <div style="width:120%">
        <el-tree
            ref="tree"
            :data="data"
            :props="defaultProps"
            :filter-node-method="filterNode"
            node-key="id"
            :expand-on-click-node="false">
          <span slot-scope="{ node, data }" class="custom-tree-node">
            <span style="font-size: 12px;" @click="tree(data)">{{data.label}}</span>
          </span>
        </el-tree>
      </div>
    </div>
    <el-main style="padding:0;margin-left: 30px;width:100vh">
      <vm-table
          ref="vmTable"
          height="59vh"
          :filter.sync="filter"
          module="basic"
          url="employees"
          @select="selectTest"
          @select-all="selectAll">
        <div slot="toolbar">
          <el-button type="primary" @click="$refs.editEmployee.open(0)">新建</el-button>
          <el-button type="danger" @click="deleteIds">批量删除</el-button>
        </div>
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="员工编号">
              <el-input v-model.trim="filter.employeeNO" clearable/>
            </vm-search>
            <vm-search label="姓名">
              <el-input v-model.trim="filter.employeeName" clearable/>
            </vm-search>
            <vm-search label="手机">
              <el-input v-model.trim="filter.mobile" clearable/>
            </vm-search>
            <vm-search label="职位">
              <el-input v-model.trim="filter.postName" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column type="selection" align="center" width="40"/>
        <el-table-column prop="employeeNO" align="center" label="员工编号"/>
        <el-table-column prop="outerNo" align="center" label="外部编号"/>
        <el-table-column prop="employeeName" align="center" width="70" label="姓名"/>
        <el-table-column prop="gender" align="center" width="45" label="性别">
          <template slot-scope="scope">
            {{constant.gender[scope.row.gender]}}
          </template>
        </el-table-column>
        <el-table-column prop="departmentName" align="center" label="部门"/>
        <el-table-column prop="postName" align="center" width="80" label="职位"/>
        <el-table-column prop="telephone" align="center" label="电话"/>
        <el-table-column prop="mobile" align="center" label="手机"/>
        <el-table-column
            label="操作"
            align="center"
            class-name="vm-table_operate"
            width="110px">
          <template slot-scope="scope">
            <el-button type="info" @click="$refs.editEmployee.open(scope.row.employeeID)">编辑</el-button>
            <el-button type="danger" @click="oneDelete(scope.row.employeeID)">删除</el-button>
          </template>
        </el-table-column>
      </vm-table>
      <employee-edit ref="editEmployee" @save-success="getList(1)"/>
    </el-main>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import EmployeeEdit from "@/views/information/Employee/EmployeeEdit";
  import constant from "../../../util/constant";
  export default {
    name: "EmployeeList",
    components: {EmployeeEdit,VmTable,VmSearch},
    data() {
      return {
        constant,
        idList: "",
        filter: {
          employeeNO: "",
          employeeName: "",
          mobile: "",
          postName: "",
          departmentID: "",
        },
        data: [],
        filterText: "",
        defaultProps: {
          children: "children",
          label: "",
          other: "",
        },
      };
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
    },
    mounted() {
      this.$refs.vmTable.getList(1);
      this.getData();
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      getData() {
        this.$http
          .get("basic","departments/tree").then((res) => {
            this.data = res;
            this.data.unshift({id: -1, label: "全  部", level: 1, children: null, parentId: null});
          });
      },
      tree(data) {
        this.filter.departmentID = data.id;
        this.getList(1);
      },
      filterNode(value, data, node) {
        //console.log(data);
        if (!value) {
          return true;
        }
        if (node.parent.parent !== null && node.parent.visible) {
          return true;
        }
        return data.label.indexOf(value) !== -1;
      },

      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      //批量删除
      deleteIds() {
        if(this.idList.length) {
          let ids = [];
          for (let item of this.idList) {
            ids.push(item.employeeID);
          }
          this.$http
            .delete("basic","/employees/idList",ids).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        }else{
          this.$message.error("请选择要删除的内容");
        }

      },
      // 单项删除
      oneDelete(id) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","/employees",id).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style lang="scss">
  .employeeList{
    .vm-search{
      .vm-search-com[data-v-658ba3ef]{
        width: 176px;
      }
    }
  }
</style>
